import { render, staticRenderFns } from "./LegacyReportsGroupCards.vue?vue&type=template&id=0e67d802&scoped=true"
import script from "./LegacyReportsGroupCards.vue?vue&type=script&lang=js"
export * from "./LegacyReportsGroupCards.vue?vue&type=script&lang=js"
import style0 from "./LegacyReportsGroupCards.vue?vue&type=style&index=0&id=0e67d802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_068c914d031cd2060dd4a326836f4c99/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e67d802",
  null
  
)

export default component.exports